import type { EnTranslation } from './en';

/** Bahasa Melayu — same shape as `en`. */
export const ms: EnTranslation = {
  header: {
    brandAlt: 'Avatar',
    title: 'Sembang dengan {{name}}',
    subtitle: 'Tanya, teroka, atau dapatkan bantuan serta-merta',
    reset: 'Set semula perbualan',
  },
  chat: {
    typing: 'Avatar sedang menaip…',
    errorFallback:
      'Maaf tentang ini. Saya tidak dapat membantu permintaan anda buat masa ini kerana isu sementara di pihak kami. Sila cuba lagi sebentar lagi.',
    networkError:
      'Ralat rangkaian. Sila semak sambungan anda dan cuba lagi.',
    widgetDisabled:
      'Sembang ini tidak lagi tersedia. Mesej baharu tidak dapat dihantar buat masa ini.',
    originNotAllowlisted:
      "Laman ini tidak dibenarkan untuk avatar ini. Minta admin tambah '{{origin}}'.",
    bundleNotAllowlisted:
      "Aplikasi ini tidak dibenarkan untuk avatar ini. Minta admin tambah '{{bundle}}'.",
    identifyDisabled: 'Pengesahan identiti dinyahaktifkan untuk avatar ini.',
    identifyRequired:
      'Log masuk diperlukan untuk avatar ini. Panggil identify(userId, hmac) sebelum bersembang.',
    retry: 'Cuba lagi',
    streamingPlaceholder: '…',
    newConversationStarted: 'Perbualan baru dimulakan',
    yesterday: 'Semalam',
  },
  input: {
    placeholder: 'Tanya apa sahaja...',
    ariaLabel: 'Mesej Avatar',
    send: 'Hantar mesej',
    attach: 'Lampirkan imej',
    attachments: 'Imej dilampirkan',
    removeAttachment: 'Buang imej {{index}}',
    poweredBy: 'Dikuasakan oleh Avatar.inc',
  },
  popular: {
    ariaLabel: 'Soalan dicadangkan',
  },
  mobile: {
    subtitle: 'Pembantu AI anda untuk {{name}}.',
    hello: 'Helo, saya {{name}}',
    heroBody:
      'Saya boleh bantu anda teroka, cipta, dan manfaatkan {{name}} dengan sepenuhnya.',
    heroHint: 'Pilih soalan di bawah atau taip mesej.',
    heroHintVoice:
      'Pilih soalan di bawah atau ketik mikrofon untuk bertanya secara suara.',
    popularHeading: 'Soalan Popular',
    placeholder: 'Tanya {{name}}...',
    back: 'Tutup',
    mic: 'Input suara',
  },
  doc: {
    title: 'Widget Avatar',
  },
};
